export function getBrowserLocales(): string[] {
	if (!navigator) {
		return [];
	}
	if (navigator.languages) {
		return Array.from(navigator.languages);
	}
	if (navigator.language) {
		return [navigator.language];
	}
	return [];
}
